/**
 * Helpers
 */
import EA from './helpers/init';
import UserAgent from './helpers/userAgent';

/* body class */
UserAgent.setBodyClass();

/**
 * Methods
 */
import './methods/exampleMethod.js';
import './methods/accordionHandler.js';
import './methods/headerSearchHandler.js';
import './methods/mobileMenuHandler.js';
import './methods/desktopDropdownHandler.js';
import './methods/imageLazyLoad.js';
import './methods/videoLazyLoad.js';
import './methods/plansCardsEqualHeight.js';
import './methods/modalHandler.js';
import './methods/cardSliderHandler.js';
import './methods/testimonialSliderHandler.js';
import './methods/expandingCardScrollAnim.js';
import './methods/heroScrollAnim.js';
import './methods/teamCardsEqualHeight.js';
import './methods/teamCardsMobileDropdownHandler.js';
import './methods/testimonialCardSliderHandler.js';
import './methods/lazyLoadSwiper.js';
import './methods/animText.js';
import './methods/animFadeBottom.js';
import './methods/customCookiebot.js';
import './methods/newsletterFormSubmitHandler.js';
import './methods/sponsoredDataLayerHandler.js';
import './methods/detectScroll.js';
import './methods/calculateHeaderBannerHeight.js';
import './methods/detailBannerLogic.js';

import { createApp } from 'vue';
import { defineAsyncComponent } from 'vue';

const app = createApp({
    mounted() {
        EA.loadMethods();
        EA.Methods.sponsoredDataLayerHandler();
    }
});

/* Components */
app.component('NewsList', defineAsyncComponent(() => import('../../components/NewsList.vue')));
app.component('TagList', defineAsyncComponent(() => import('../../components/TagList.vue')));
app.component('SearchList', defineAsyncComponent(() => import('../../components/SearchList.vue')));
app.component('SearchInput', defineAsyncComponent(() => import('../../components/SearchInput.vue')));

/* Add Pinia store */
// import { createPinia } from 'pinia';
// const pinia = createPinia();
// app.use(pinia);

app.mount('#app');
